import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import vrvnw from "../../../components/tables/vr-vnw";

const data = [
  {
    les: "22",
    table: vrvnw
  }
];

export default () => (
  <TableSelector
    defaultChapter="22"
    data={data}
    title="Vragend voornaamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/vragend-voornaamwoord.js